export const routeName = 'solutions';
export const slugs: Record<string, string> = {
	es: 'soluciones',
	en: 'solutions',
	ca: 'solucions',
	fr: 'solutions',
	it: 'soluzioni',
};
export const sitemap = { changefreq: 'monthly', priority: '0.9', lastmod: '2026-08-21' };
